import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { PrimaryButton } from "@/components/agent/ui";
import { SecretKey } from "@/components/agent/SecretKey";
import { PropertyForm } from "@/components/agent/PropertyForm";
import { PropertyKeys } from "@/components/agent/PropertyKeys";

const Step = ({ n, title, text, done, children, testid }) => (
  <section className="flex gap-4 p-5" data-testid={testid}>
    <span className={cn("grid size-6 shrink-0 place-items-center rounded-full text-xs font-medium",
      done ? "bg-primary text-primary-foreground" : "border text-muted-foreground")}>
      {done ? <Check className="size-3.5" /> : n}
    </span>
    <div className="flex min-w-0 flex-1 flex-col gap-3">
      <div>
        <h2 className="text-sm font-medium">{title}</h2>
        <p className="text-xs text-muted-foreground">{text}</p>
      </div>
      {children}
    </div>
  </section>
);

export const SetupChecklist = ({ created, onCreated, onFinish }) => (
  <div className="divide-y rounded-xl border bg-background" data-testid="setup-checklist">
    <Step n={1} title="Secret key" text="Lets your website create properties for you." done testid="setup-step-secret">
      <SecretKey />
    </Step>
    <Step n={2} title="First property" text="The address, rent and who can apply." done={!!created} testid="setup-step-property">
      {created ? <p className="text-sm text-muted-foreground" data-testid="setup-property-saved">{created.address} saved.</p> : <PropertyForm onSaved={onCreated} />}
    </Step>
    <Step n={3} title="Apply link" text="Put it on your listing. Applicants start here." done={!!created} testid="setup-step-keys">
      {created ? (
        <>
          <PropertyKeys linkToken={created.link_token} />
          <div><PrimaryButton onClick={onFinish} testid="setup-finish-button">Go to applicants</PrimaryButton></div>
        </>
      ) : <p className="text-sm text-muted-foreground">Appears once your first property is saved.</p>}
    </Step>
  </div>
);
